import React from 'react';
import './App.css';

function Blop() {
	return (
		<h1> Hello World! </h1>
	);
}

export default Blop;